(function () {
    "use strict";

    angular.module("app.search").factory("SearchService", SearchService);

    SearchService.$inject = ["$http", "$q"];

    function SearchService($http, $q) {
        var service = {
            searchProduct: searchProduct,
            searchCategory: searchCategory,
            searchSalesPoint: searchSalesPoint,
            getLastViewProducts: getLastViewProducts,
        };

        return service;

        function searchProduct(search, cultures) {
            var deferred = $q.defer();
            var url = "/General/SearchProduct?search=" + search+"&Culture=" +cultures;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchCategory(search, cultures) {
            var deferred = $q.defer();
            var url = "/General/SearchCategory?search=" + search + "&Culture=" + cultures;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchSalesPoint(search, cultures) {
            var deferred = $q.defer();
            var url = "/General/SearchSalesPoint/" + search + "&Culture=" + cultures;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getLastViewProducts() {
            var deferred = $q.defer();
            var url = "General/LastViewProducts";

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();
